import { render } from "./Unit2-1-game.vue?vue&type=template&id=4dc66cb2&scoped=true"
import script from "./Unit2-1-game.vue?vue&type=script&lang=js"
export * from "./Unit2-1-game.vue?vue&type=script&lang=js"

import "./Unit2-1-game.vue?vue&type=style&index=0&id=4dc66cb2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc66cb2"]])

export default __exports__